import styles from "./Map.module.css";
import umap from "../../img/umap.jpg";
import emap from "../../img/emap.jpg";
import streetmap from "../../img/streetmap.jpg";
import emap_new from "../../img/emap_new.png";
import streetmap_new from "../../img/streetmap_new.png";
import { Dispatch, MouseEvent, SetStateAction, useEffect } from "react";

interface MapProps {
    mapType: string;
    setMapType: Dispatch<SetStateAction<string>>;
}

/**
 * @author cjs
 * @date 2024-09-27 10:29:59
 * @remark 지도만들기 지도 종류 설정 사용자 설정 화면 컴포넌트
 * @pram props
 * @props MapProps
 *      mapType(required) : 지도 종류
 *      setMapType: 지도 종류 변경 함수
 */
function Map(props: MapProps) {
    useEffect(() => {}, [props.mapType]);
    const clickMapType = (e: MouseEvent<HTMLElement>) => {
        if (e.currentTarget.id != "uMap") {
            props.setMapType(e.currentTarget.id);
        }
    };

    return (
        // <div className={styles.wrapMapType}>
        //     <ul className={styles.wrapMapTypeItem}>
        //         <li className={styles.mapTypeItem}>
        //             <button id="baroEmap" className={`${styles.mapTypeItemBtn} ${props.mapType === "baroEmap" ? styles.active:""}`} onClick={clickMapType}>
        //                 <img className={styles.mapTypeItemImg} src={emap} alt="바로e맵"/>
        //             </button>
        //         </li>
        //         <li className={styles.mapTypeItem}>
        //             <button id="OSM" className={`${styles.mapTypeItemBtn} ${props.mapType === "OSM" ? styles.active:""}`} onClick={clickMapType}>
        //                 <img className={styles.mapTypeItemImg} src={streetmap} alt="Open Street Map"/>
        //             </button>
        //         </li>
        //         {/* <li className={styles.mapTypeItem}>
        //             <button id="uMap" className={`${styles.mapTypeItemBtn} ${styles.preparing} ${props.mapType === "uMap" ? styles.active:""}`} onClick={clickMapType}>
        //                 <div className={styles.screen}>
        //                     <p>uMap</p>
        //                     <span>준비중</span>
        //                 </div>
        //                 <img className={styles.mapTypeItemImg} src={umap} alt="uMap"/>
        //             </button>
        //         </li> */}
        //     </ul>
        // </div>
        <div className={styles.wrapMapType}>
            <div className={styles.mapTypeItem}>
                <button
                    className={`${styles.mapTypeItemBtn} ${props.mapType === "baroEmap" ? styles.active : ""}`}
                    id="baroEmap"
                    onClick={clickMapType}
                >
                    <img className={styles.mapTypeItemImg} src={emap_new} alt="바로e맵" />
                </button>
            </div>
            <div className={styles.mapTypeItem}>
                <button className={`${styles.mapTypeItemBtn} ${props.mapType === "OSM" ? styles.active : ""}`} id="OSM" onClick={clickMapType}>
                    <img className={styles.mapTypeItemImg} src={streetmap_new} alt="Open Street Map" />
                </button>
            </div>
        </div>
    );
}

export default Map;
